import { Button } from "@shared/ui/Button";
import { PhaseAction } from "@platform/types/platform.types";
import { useUpdateUserPhaseActionStatus } from "@platform/hooks/useUpdateUserPhaseActionStatus";
import { useGetOrCreateQuizResponse } from "@platform/features/quiz/hooks/useGetOrCreateQuizResponse";
import { useDialog } from "@shared/features/dialog/useDialog";
import { usePlatform } from "@platform/PlatformContext";

export type Props = {
  action: PhaseAction;
};

export function VideoUIEndQuizAction({ action }: Props) {
  const { user } = usePlatform();

  const quizMutation = useGetOrCreateQuizResponse({
    quizId: action?.target_object?.id,
    userId: user?.id,
    status: "in_progress",
    type: action.type,
  });

  const { mutate: setToInProgressUserPhaseActionStatus } =
    useUpdateUserPhaseActionStatus({
      userPhaseActionId: parseInt(action?.id, 10),
      status: "in_progress",
    });

  const { openDialog } = useDialog();

  const onSurveyClick = async () => {
    if (!action) {
      return;
    }

    const result = await quizMutation?.mutateAsync();

    openDialog("quiz", {
      quizResponseId: result.quiz_response.id,
      userPhaseActionId: action.id,
    });

    setToInProgressUserPhaseActionStatus();
  };

  return (
    <Button onClick={onSurveyClick} variant="primary">
      Take Survey
    </Button>
  );
}

export default VideoUIEndQuizAction;
